import { useState } from "react";
import {
    Alert,
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Spinner
} from "reactstrap";

import GroupLearningLocationService from "../Services/GroupLearningLocationService";

import {
    CreateGroupLearningLocationDto,
    GroupLearningDashboardDto,
    LearningMode
} from "../types/GroupLearningLocation"; 
import { LocationItem } from "../types/Location";

interface Props {
    groupId: string;
    dashboard?: GroupLearningDashboardDto;
    isEdit: boolean;
    onSaved: () => void;
    onCancel: () => void;
}

const locations: LocationItem[] = [
    { country: "India", state: "Andhra Pradesh", district: "Visakhapatnam" },
    { country: "India", state: "Andhra Pradesh", district: "Krishna (Vijayawada)" },
    { country: "India", state: "Andhra Pradesh", district: "Guntur" },
    { country: "India", state: "Andhra Pradesh", district: "Chittoor (Tirupati)" },

    { country: "India", state: "Arunachal Pradesh", district: "Papum Pare (Itanagar)" },
    { country: "India", state: "Arunachal Pradesh", district: "Tawang" },
    { country: "India", state: "Arunachal Pradesh", district: "West Kameng" },
    { country: "India", state: "Arunachal Pradesh", district: "Changlang" },

    { country: "India", state: "Assam", district: "Kamrup (Guwahati)" },
    { country: "India", state: "Assam", district: "Dibrugarh" },
    { country: "India", state: "Assam", district: "Jorhat" },
    { country: "India", state: "Assam", district: "Cachar (Silchar)" },

    { country: "India", state: "Bihar", district: "Patna" },
    { country: "India", state: "Bihar", district: "Gaya" },
    { country: "India", state: "Bihar", district: "Muzaffarpur" },
    { country: "India", state: "Bihar", district: "Bhagalpur" },

    { country: "India", state: "Chhattisgarh", district: "Raipur" },
    { country: "India", state: "Chhattisgarh", district: "Durg" },
    { country: "India", state: "Chhattisgarh", district: "Bilaspur" },
    { country: "India", state: "Chhattisgarh", district: "Korba" },

    { country: "India", state: "Goa", district: "North Goa" },
    { country: "India", state: "Goa", district: "South Goa" },

    { country: "India", state: "Gujarat", district: "Ahmedabad" },
    { country: "India", state: "Gujarat", district: "Surat" },
    { country: "India", state: "Gujarat", district: "Vadodara" },
    { country: "India", state: "Gujarat", district: "Rajkot" },

    { country: "India", state: "Haryana", district: "Gurugram" },
    { country: "India", state: "Haryana", district: "Faridabad" },
    { country: "India", state: "Haryana", district: "Panipat" },
    { country: "India", state: "Haryana", district: "Hisar" },

    { country: "India", state: "Himachal Pradesh", district: "Shimla" },
    { country: "India", state: "Himachal Pradesh", district: "Kangra" },
    { country: "India", state: "Himachal Pradesh", district: "Mandi" },
    { country: "India", state: "Himachal Pradesh", district: "Solan" },

    { country: "India", state: "Jharkhand", district: "Ranchi" },
    { country: "India", state: "Jharkhand", district: "Dhanbad" },
    { country: "India", state: "Jharkhand", district: "East Singhbhum (Jamshedpur)" },
    { country: "India", state: "Jharkhand", district: "Bokaro" },

    { country: "India", state: "Karnataka", district: "Bangalore City" },
    { country: "India", state: "Karnataka", district: "Mysore" },
    { country: "India", state: "Karnataka", district: "Dakshina Kannada (Mangaluru)" },
    { country: "India", state: "Karnataka", district: "Belgaum" },

    { country: "India", state: "Kerala", district: "Thiruvananthapuram" },
    { country: "India", state: "Kerala", district: "Ernakulam (Kochi)" },
    { country: "India", state: "Kerala", district: "Kozhikode" },
    { country: "India", state: "Kerala", district: "Thrissur" },

    { country: "India", state: "Madhya Pradesh", district: "Bhopal" },
    { country: "India", state: "Madhya Pradesh", district: "Indore" },
    { country: "India", state: "Madhya Pradesh", district: "Jabalpur" },
    { country: "India", state: "Madhya Pradesh", district: "Gwalior" },

    { country: "India", state: "Maharashtra", district: "Mumbai City" },
    { country: "India", state: "Maharashtra", district: "Pune" },
    { country: "India", state: "Maharashtra", district: "Nagpur" },
    { country: "India", state: "Maharashtra", district: "Thane" },

    { country: "India", state: "Manipur", district: "Imphal West" },
    { country: "India", state: "Manipur", district: "Imphal East" },
    { country: "India", state: "Manipur", district: "Churachandpur" },
    { country: "India", state: "Manipur", district: "Thoubal" },

    { country: "India", state: "Meghalaya", district: "East Khasi Hills" },
    { country: "India", state: "Meghalaya", district: "West Garo Hills" },
    { country: "India", state: "Meghalaya", district: "Ri Bhoi" },
    { country: "India", state: "Meghalaya", district: "Jaintia Hills" },

    { country: "India", state: "Mizoram", district: "Aizawl" },
    { country: "India", state: "Mizoram", district: "Lunglei" },
    { country: "India", state: "Mizoram", district: "Champhai" },
    { country: "India", state: "Mizoram", district: "Kolasib" },

    { country: "India", state: "Nagaland", district: "Dimapur" },
    { country: "India", state: "Nagaland", district: "Kohima" },
    { country: "India", state: "Nagaland", district: "Mokokchung" },
    { country: "India", state: "Nagaland", district: "Mon" },

    { country: "India", state: "Odisha", district: "Khordha (Bhubaneswar)" },
    { country: "India", state: "Odisha", district: "Cuttack" },
    { country: "India", state: "Odisha", district: "Puri" },
    { country: "India", state: "Odisha", district: "Ganjam" },

    { country: "India", state: "Punjab", district: "Ludhiana" },
    { country: "India", state: "Punjab", district: "Amritsar" },
    { country: "India", state: "Punjab", district: "Jalandhar" },
    { country: "India", state: "Punjab", district: "Patiala" },

    { country: "India", state: "Rajasthan", district: "Jaipur" },
    { country: "India", state: "Rajasthan", district: "Jodhpur" },
    { country: "India", state: "Rajasthan", district: "Udaipur" },
    { country: "India", state: "Rajasthan", district: "Kota" },

    { country: "India", state: "Sikkim", district: "East Sikkim" },
    { country: "India", state: "Sikkim", district: "North Sikkim" },
    { country: "India", state: "Sikkim", district: "South Sikkim" },
    { country: "India", state: "Sikkim", district: "West Sikkim" },

    { country: "India", state: "Tamil Nadu", district: "Chennai" },
    { country: "India", state: "Tamil Nadu", district: "Coimbatore" },
    { country: "India", state: "Tamil Nadu", district: "Madurai" },
    { country: "India", state: "Tamil Nadu", district: "Tiruchirappalli" },

    { country: "India", state: "Telangana", district: "Hyderabad" },
    { country: "India", state: "Telangana", district: "Ranga Reddy" },
    { country: "India", state: "Telangana", district: "Medchal–Malkajgiri" },
    { country: "India", state: "Telangana", district: "Warangal Urban" },

    { country: "India", state: "Tripura", district: "West Tripura" },
    { country: "India", state: "Tripura", district: "Gomti" },
    { country: "India", state: "Tripura", district: "North Tripura" },
    { country: "India", state: "Tripura", district: "Dhalai" },

    { country: "India", state: "Uttar Pradesh", district: "Lucknow" },
    { country: "India", state: "Uttar Pradesh", district: "Kanpur Nagar" },
    { country: "India", state: "Uttar Pradesh", district: "Ghaziabad" },
    { country: "India", state: "Uttar Pradesh", district: "Varanasi" },

    { country: "India", state: "Uttarakhand", district: "Dehradun" },
    { country: "India", state: "Uttarakhand", district: "Haridwar" },
    { country: "India", state: "Uttarakhand", district: "Nainital" },
    { country: "India", state: "Uttarakhand", district: "Udham Singh Nagar" },

    { country: "India", state: "West Bengal", district: "Kolkata" },
    { country: "India", state: "West Bengal", district: "Howrah" },
    { country: "India", state: "West Bengal", district: "North 24 Parganas" },
    { country: "India", state: "West Bengal", district: "Darjeeling" }
];
const LearningPreferenceForm = ({
    groupId,
    dashboard,
    isEdit,
    onSaved,
    onCancel
}: Props) => {

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");

    const [mode, setMode] = useState<LearningMode>(
        dashboard?.learningMode ?? LearningMode.Online
    );

    const [state, setState] = useState(
        dashboard?.state ?? ""
    );

    const [district, setDistrict] = useState(
        dashboard?.district ?? ""
    );

    const [area, setArea] = useState(
        dashboard?.area ?? ""
    );
    const getStates = (): string[] => {

    return Array.from(
        new Set(
            locations.map(x => x.state)
        )
    ).sort();

};

const getDistricts = (
    state: string
): string[] => {

    return Array.from(
        new Set(
            locations
                .filter(x => x.state === state)
                .map(x => x.district)
        )
    ).sort();

};

    const submit = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        setError("");

        if (
            mode === LearningMode.InPerson &&
            (!state.trim() || !district.trim())
        ) {
            setError("State and District are required.");
            return;
        }

        const dto: CreateGroupLearningLocationDto = {

            groupId,

            learningMode: mode,

            country: "India",

            state:
                mode === LearningMode.InPerson
                    ? state.trim()
                    : undefined,

            district:
                mode === LearningMode.InPerson
                    ? district.trim()
                    : undefined,

            area:
                mode === LearningMode.InPerson
                    ? area.trim()
                    : undefined
        };

        try {

            setLoading(true);

            if (isEdit) {

                await GroupLearningLocationService.update(dto);

            } else {

                await GroupLearningLocationService.create(dto);

            }

            onSaved();

        }
        catch (e: any) {

            setError(
                e?.response?.data?.message ??
                e?.response?.data ??
                "Unable to save learning preference."
            );

        }
        finally {

            setLoading(false);

        }

    };

    return (
 
        <Form onSubmit={submit} className="mt-3">

            {error && (

                <Alert color="danger">

                    {error}

                </Alert>

            )}

<div className="d-flex">

 <FormGroup check className="me-4">

                <Input
                    id="online"
                    type="radio"
                    onChange={() =>
                        setMode(LearningMode.Online)
                    }
                />

                <Label
                    check
                    for="online"
                    style={{fontSize:'18px',fontWeight:'800'}}
                >
                    🌐 Online
                </Label>

            </FormGroup>

            <FormGroup
                check
                className="me-4"
            >

                <Input
                    id="inperson"
                    type="radio"
                    checked={mode === LearningMode.InPerson}
                    onChange={() =>
                        setMode(LearningMode.InPerson)
                    }
                />

                <Label
                    check
                    for="inperson"
                    style={{fontSize:'18px',fontWeight:'800'}}
                >
                    📍 In Person
                </Label>
            </FormGroup>


</div>
           

            {mode === LearningMode.InPerson && (

                <>

                   

                     <FormGroup >

    
    <Input
    className="mt-2"
        type="select"
        value={state}
        onChange={(e) => {

            setState(e.target.value);
            setDistrict("");

        }}

        style={{width:'300px'}}
    >

        <option value="">
            Select State
        </option>

        {getStates().map((item) => (

            <option
                key={item}
                value={item}
            >
                {item}
            </option>

        ))}

    </Input>

</FormGroup>


                  
                     <FormGroup>

    

    <Input
        type="select"
        value={district}
        disabled={!state}
        onChange={(e) =>
            setDistrict(e.target.value)
        }
        style={{width:'300px'}}
    >

        <option value="">
            Select District
        </option>

        {getDistricts(state).map((item) => (

            <option
                key={item}
                value={item}
            >
                {item}
            </option>

        ))}

    </Input>

</FormGroup>

                    <FormGroup>
 

                        <Input
                            value={area}
                            placeholder="Enter Area"
                            onChange={(e) =>
                                setArea(e.target.value)
                            }
                            style={{width:'300px'}}
                        />

                    </FormGroup>

                </>

            )}

            <div className="d-flex">

                <Button
                    color="primary"
                    type="submit"
                    disabled={loading}
                    className="mt-3"
                >

                    {loading ? (

                        <Spinner size="sm" />

                    ) : (

                        isEdit
                            ? "Update Preference"
                            : "Submit Preference"

                    )}

                </Button>

                {isEdit && (

                    <Button
                        color="secondary"
                        type="button"
                        onClick={onCancel}
                        style={{height:"40px" , marginTop:"15px", marginLeft:"15px"}}
                    >
                        Cancel
                    </Button>

                )}

            </div>

        </Form>

    );

};

export default LearningPreferenceForm;